import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Toolbox } from 'src/app/classes/toolbox';
import { ToolboxRead } from 'src/app/classes/toolbox-read';
import { CodaltComponent } from 'src/app/codalt.component';
import { Question, QuestionsService } from 'src/app/services/questions.service';
import { ToolboxService } from 'src/app/services/toolbox.service';
import { LocalStorage } from 'src/app/storage.class';
import { environment } from '../../../../environments/environment';
import { QuizComponent } from '../quiz/quiz.component';

@Component({
    selector: 'app-toolbox-dialog',
    templateUrl: './toolbox-dialog.component.html',
    styleUrls: ['./toolbox-dialog.component.scss'],
    standalone: false,
})
export class ToolboxDialogComponent extends CodaltComponent implements OnInit {
    pdfUrl: string;
    toolbox: Toolbox;
    read: ToolboxRead;
    showClose = false;
    secToClose = 6;
    questions: Question[];
    pdfData: { singlePdf: string; viewIndex: number };

    constructor(
        public dialogRef: MatDialogRef<ToolboxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Toolbox,
        private toolboxService: ToolboxService,
        private questionService: QuestionsService,
        public dialog: MatDialog
    ) {
        super();
        this.toolbox = data;
        if (data) {
            this.pdfUrl = `${environment.apiEndpoint}toolbox/pdf/${data.id}?access_token=${LocalStorage.getUserToken()}`;
            this.pdfData = { singlePdf: this.pdfUrl, viewIndex: 0 };
        }
    }

    ngOnInit(): void {
        if (this.toolbox && !this.toolbox.read) {
            const interval = setInterval(() => {
                this.secToClose--;
            }, 1000);
            setTimeout(() => {
                this.showClose = true;
                this.toolboxService.readToolbox(this.toolbox.id).subscribe(read => {
                    this.read = read.data;
                });
                clearInterval(interval);
            }, this.secToClose * 1000);
        } else {
            this.showClose = true;
        }

        this.questionService.getQuestions(this.toolbox.id).subscribe({
            next: response => {
                this.questions = response;
            },
        });
    }

    close() {
        this.dialogRef.close(this.read);
    }

    openQuiz() {
        this.dialogRef.afterClosed().subscribe(() => {
            setTimeout(() => {
                this.dialog.open(QuizComponent, {
                    data: { id: this.toolbox.id },
                    width: '99vw',
                    maxWidth: '1300px',
                    height: '99vh',
                    minHeight: '500px',
                    maxHeight: '99vh',
                    disableClose: true,
                });
            });
        });

        this.dialogRef.close(this.read);
    }

    protected readonly history = history;
}
